import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ce7d3dcc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ce7d3dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7d3dcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce7d3dcc')) {
      api.createRecord('ce7d3dcc', component.options)
    } else {
      api.reload('ce7d3dcc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ce7d3dcc&scoped=true&", function () {
      api.rerender('ce7d3dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VQ9D8Ybu40qs/JS/comp/PopupBox.vue"
export default component.exports